export function compactOrderNumber(value: string | null | undefined): string {
  if (!value) return "";
  const segments = /^([0-9]+)-([0-9]+)$/.exec(value);
  if (!segments) return value;
  return segments.slice(1).map(function (segment) {
    return segment.replace(/^0+(?=[0-9])/, "");
  }).join("-");
}
